/**
 * Iatrode.UI - Button Dropdown Component
 * 轻量按钮下拉菜单，复用 Avatar Dropdown 的菜单样式体系
 */

(function($) {
    'use strict';

    const DEFAULTS = {
        placement: 'auto',      // auto | bottom-start | bottom-end | top-start | top-end
        offset: 8,
        viewportMargin: 16,
        autoClose: true
    };

    function getDropdownCore() {
        return window.IatrodeUI && window.IatrodeUI.dropdown ? window.IatrodeUI.dropdown : null;
    }

    class ButtonDropdown {
        constructor(element, options) {
            this.$element = $(element);
            this.options = $.extend({}, DEFAULTS, options);
            this.$toggle = this.$element.find('.btn-dropdown-toggle').first();
            this.$menu = this.$element.find('.dropdown-menu').first();
            this.isOpen = false;
            this.instanceId = 'btn-dropdown-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
            this._resizeTimer = null;
            this.init();
        }

        init() {
            if (!this.$menu.length) {
                return;
            }

            if (!this.$toggle.length) {
                // 容器内无显式触发器时，默认取第一个按钮
                this.$toggle = this.$element.find('.btn').first();
                this.$toggle.addClass('btn-dropdown-toggle');
            }

            this.$element.addClass('btn-dropdown');
            this.$menu
                .addClass('btn-dropdown-menu ui-avatar-dropdown ui-avatar-dropdown-select-like')
                .attr('data-button-dropdown-instance', this.instanceId);

            this.bindEvents();
        }

        bindEvents() {
            const self = this;

            this.$toggle.on('click.ui.button.dropdown', function(e) {
                e.preventDefault();
                e.stopPropagation();
                self.toggle();
            });

            this.$menu.on('click.ui.button.dropdown', '.dropdown-item', function(e) {
                e.stopPropagation();
                const noClose = $(this).data('no-close') === true || $(this).data('no-close') === 'true';
                if (self.options.autoClose && !noClose) {
                    self.hide();
                }
            });

            $(document).on('click.ui.button.dropdown.' + this.instanceId, function(e) {
                if (!self.isOpen) return;
                if (self.$element.is(e.target) || self.$element.has(e.target).length) return;
                if (self.$menu.is(e.target) || self.$menu.has(e.target).length) return;
                self.hide();
            });

            $(window).on('resize.ui.button.dropdown.' + this.instanceId + ' orientationchange.ui.button.dropdown.' + this.instanceId, function() {
                if (!self.isOpen) return;
                window.clearTimeout(self._resizeTimer);
                self._resizeTimer = window.setTimeout(function() {
                    self.positionMenu();
                }, 120);
            });

            $(window).on('scroll.ui.button.dropdown.' + this.instanceId, function() {
                if (self.isOpen) {
                    self.hide();
                }
            });
        }

        toggle() {
            if (this.isOpen) {
                this.hide();
            } else {
                this.show();
            }
        }

        show() {
            if (this.isOpen || !this.$menu.length || !this.$toggle.length) return;

            $('.btn-dropdown.is-open').not(this.$element).each(function() {
                const instance = $(this).data('ui.buttonDropdown.instance');
                if (instance) {
                    instance.hide();
                }
            });

            if (this.$menu.parent()[0] !== document.body) {
                this.$menu.appendTo(document.body);
            }

            this.$element.addClass('is-open');
            this.isOpen = true;

            this.positionMenu();

            const core = getDropdownCore();
            if (core) {
                core.show(this.$menu[0]);
            } else {
                const menuStyle = this.$menu[0]?.style;
                if (menuStyle) {
                    menuStyle.setProperty('opacity', '1', 'important');
                    menuStyle.setProperty('visibility', 'visible', 'important');
                    menuStyle.setProperty('transform', 'translateY(0)', 'important');
                    menuStyle.setProperty('display', 'block', 'important');
                }
            }

            this.$menu.addClass('show');
            this.$toggle.attr('aria-expanded', 'true');
        }

        positionMenu() {
            const menuEl = this.$menu[0];
            const toggleEl = this.$toggle[0];
            if (!menuEl || !toggleEl) return;

            const core = getDropdownCore();
            if (core) {
                core.place(menuEl, toggleEl, {
                    placement: this.options.placement,
                    offset: this.options.offset,
                    viewportMargin: this.options.viewportMargin,
                    appendToBody: true,
                    visible: this.isOpen,
                    preferEndOnRight: true
                });
                return;
            }
        }

        hide() {
            if (!this.isOpen) return;
            this.isOpen = false;
            this.$element.removeClass('is-open');
            this.$menu.removeClass('show');
            this.$toggle.attr('aria-expanded', 'false');

            const menuStyle = this.$menu[0]?.style;
            const core = getDropdownCore();
            if (core) {
                core.hide(this.$menu[0]);
            } else if (menuStyle) {
                menuStyle.setProperty('opacity', '0', 'important');
                menuStyle.setProperty('visibility', 'hidden', 'important');
                menuStyle.setProperty('transform', 'translateY(-10px)', 'important');
                menuStyle.setProperty('display', 'none', 'important');
            }
        }

        destroy() {
            this.hide();
            this.$toggle.off('.ui.button.dropdown');
            this.$menu.off('.ui.button.dropdown');
            $(document).off('.' + this.instanceId);
            $(window).off('.' + this.instanceId);
            window.clearTimeout(this._resizeTimer);
            this.$element.removeData('ui.buttonDropdown.instance').removeClass('btn-dropdown is-open');
        }
    }

    $.fn.buttonDropdown = function(options) {
        return this.each(function() {
            let instance = $(this).data('ui.buttonDropdown.instance');

            if (typeof options === 'string') {
                if (instance && typeof instance[options] === 'function') {
                    instance[options]();
                }
                return;
            }

            if (instance) {
                instance.destroy();
            }

            instance = new ButtonDropdown(this, options);
            $(this).data('ui.buttonDropdown.instance', instance);
        });
    };

    $(document).ready(function() {
        $('[data-toggle="button-dropdown"]').each(function() {
            const $this = $(this);
            $this.buttonDropdown({
                placement: $this.data('placement') || 'auto',
                offset: parseInt($this.data('offset'), 10) || DEFAULTS.offset,
                autoClose: !($this.data('auto-close') === false || $this.data('auto-close') === 'false')
            });
        });
    });

})(jQuery);
